import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'

const href = window.location.href

const segments = new URL(href).pathname.split('/')
const last = segments.pop() || segments.pop() // Handle potential trailing slash
// console.log('last', last)

let collectionHandle = window.collectionHandle ? window.collectionHandle : last

const el = document.getElementById('root')

const collectionID = el.getAttribute('data-collection-id')

const collectionTitle = el.getAttribute('data-collection-title')

const collectionPage = el.getAttribute('data-page') ? el.getAttribute('data-page') : ''

console.log('collectionID', collectionID)

ReactDOM.render(
    <React.StrictMode>
        {collectionID && (
            <App
                collectionHandle={collectionHandle}
                collectionId={collectionID}
                collectionPage={collectionPage}
                collectionTitle={collectionTitle}
            />
        )}
    </React.StrictMode>,
    el
)
